import { useState } from 'react';
import { Link } from 'react-router-dom';

export const CookieConsent = () => {
  const [visible, setVisible] = useState(() => !localStorage.getItem('daakyi_cookie_consent'));

  const decide = (choice) => {
    localStorage.setItem('daakyi_cookie_consent', choice);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div data-testid="cookie-consent-banner"
      className="fixed bottom-4 left-4 right-4 sm:right-auto sm:max-w-[400px] z-50 border border-[#E2E8F0] bg-white/95 backdrop-blur-xl rounded-xl shadow-[0_8px_30px_rgba(15,23,42,0.12)]">
      <div className="p-4">
        <div className="mb-3">
          <p className="text-[#374151] text-xs leading-relaxed">
            We use essential cookies to make this site work, and optional analytics cookies to improve it.
            See our <Link to="/privacy" className="text-[#A8631A] hover:underline">Privacy Policy</Link>.
          </p>
        </div>
        <div className="flex items-center justify-end gap-2">
          <button data-testid="cookie-decline-btn" onClick={() => decide('declined')}
            className="px-4 py-2 rounded-lg border border-[#E2E8F0] text-[#6B7280] text-xs font-medium hover:text-[#1A1240] hover:border-[#F29B3D]/30 transition-all">
            Decline
          </button>
          <button data-testid="cookie-accept-btn" onClick={() => decide('accepted')}
            className="px-5 py-2 rounded-lg bg-[#F29B3D] text-white text-xs font-bold hover:bg-[#DD8226] transition-all">
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
